import {
    TradingProcedureListQueryPort
} from '../../../../features/trading-procedure-list/application/ports/trading-procedure-list-query.port';
import { Observable, map } from 'rxjs';
import { TradingProcedure } from '../../../../features/trading-procedure-list/domain/trading-procedure.model';
import { TradingProcedureApi } from '@tradgine/data-access/tradgine-data';
import { inject } from '@angular/core';
import { toTradingProcedure } from '../mappers/trading-procedure.mapper';
import { Result } from '@hereisyourgitanton/core';

export class TradingProcedureListQueryAdapter implements TradingProcedureListQueryPort {
    private readonly tradingProcedureApi = inject(TradingProcedureApi);

    getAll(): Observable<Result<TradingProcedure[], Error>> {
        return this.tradingProcedureApi.getAll().pipe(
            map(
                (result) =>
                    result
                        .map((tps) => tps.map(toTradingProcedure))
                        .mapErr((err) => new Error('Failed to fetch trading procedures')) // TODO localize or use type error?
            )
        );
    }

    getById(id: number): Observable<Result<TradingProcedure, Error>> {
        return this.tradingProcedureApi.getById(id).pipe(
            map(
                (result) =>
                    result
                        .map(toTradingProcedure)
                        .mapErr((err) => new Error('Failed to fetch trading procedure')) // TODO localize or use type error?
            )
        );
    }
}
